<template>
  <a
    v-if="safeHref"
    :href="safeHref"
    class="logo-link"
    target="_blank"
    rel="noopener noreferrer"
    :aria-label="linkAriaLabel"
  >
    <div
      class="logo-container relative"
      :class="{ mini: mini, centered: centered }"
      aria-hidden="true"
    >
      <q-icon :name="logo" />
    </div>
  </a>
  <div
    v-else
    class="logo-container relative"
    :class="{ mini: mini, centered: centered }"
    role="img"
    :aria-label="ariaLabel"
  >
    <q-icon :name="logo" />
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  import { validateUrlProtocol } from 'src/services/helpers/security.helper'

  const props = defineProps({
    mini: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: 'Subtrace',
    },
    href: {
      type: String,
      default: null,
    },
    linkAriaLabel: {
      type: String,
      default: 'Open website (opens in new tab)',
    },
  })

  const logo = computed(() => {
    return props.mini ? 'img:/assets/project-logo-mini.svg' : 'img:/assets/project-logo.svg'
  })

  const safeHref = computed(() => {
    if (!props.href) return null
    const { isValid, normalizedUrl } = validateUrlProtocol(props.href)
    return isValid ? normalizedUrl : null
  })
</script>

<style lang="scss">
  .logo-link {
    display: inline-flex;
    text-decoration: none;
    color: inherit;

    &:focus-visible {
      outline: 2px solid $primary;
      outline-offset: 0.125rem;
      border-radius: 0.25rem;
    }
  }

  .logo-container {
    margin-inline-start: 0.6rem;
    pointer-events: none;

    &.centered {
      margin-inline-start: 0;
    }

    &.mini {
      margin-inline-start: 0;
    }

    .q-icon {
      min-height: 3rem;
      width: auto;
    }

    img {
      min-height: 3rem;
      height: 3rem;
      max-height: 3rem;
    }

    &.mini .q-icon {
      min-height: 2.5rem;
      height: 2.5rem;
      max-height: 2.5rem;
    }

    &.mini img {
      min-height: 2.5rem;
      height: 2.5rem;
      max-height: 2.5rem;
    }
  }
</style>
